export default "__VITE_ASSET__BDgv$J33__"